<template>
  <div>
    <v-overlay :value="overlay" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card>
      <v-toolbar flat color="white">
        <v-toolbar-title>
          <v-icon class="mb-1">mdi-package-variant-closed-check</v-icon>
          RESUMEN DE PIEZAS
        </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-text-field
          v-model="desde"
          @click:append="cargarLista()"
          @keyup.enter="cargarLista()"
          @change="cargarLista()"
          small
          type="date"
          append-icon="mdi-magnify"
          label="Desde"
          single-line
          class="mt-5 mx-1"
        >
        </v-text-field>
        <v-text-field
          v-model="hasta"
          @click:append="cargarLista()"
          small
          @keyup.enter="cargarLista()"
          type="date"
          clearable
          @change="cargarLista()"
          append-icon="mdi-magnify"
          label="Hasta"
          single-line
          class="mt-5 mx-2"
        >
        </v-text-field>

        <v-text-field
          v-model="searchAwb"
          append-icon="mdi-magnify"
          label="AWB"
          single-line
          class="mt-5 mx-2"
          @keyup.enter="cargarLista()"
          @click:append="cargarLista()"
          @change="cargarLista()"
        ></v-text-field>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-toolbar flat>
        <v-btn small color="primary" @click="exportar"
          ><v-icon left>mdi-file-excel</v-icon>Exportar</v-btn
        >
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="lista"
        :items-per-page="itemsPerPage"
        :loading="loadingTable"
        class="elevation-1 mx-4"
      >
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import Vue from "vue";

export default {
  name: "ResumenPiezas",
  data: () => ({
    overlay: false,
    headers: [
      { text: "AWB", value: "AWB_NUM" },
      { text: "Shipper", value: "SHIPPER" },
      { text: "Cliente", value: "CLIENTE" },
      { text: "Piezas", value: "PIEZAS" },
    ],

    requiredRule: [(v) => !!v || "El campo es requerido"],
    emailRules: [
      (v) =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "Ingrese un Email válido",
    ],
    lista: [],
    options: {},
    dialog: false,
    notifications: false,
    sound: true,
    widgets: true,
    desde: "",
    hasta: "",
    searchAwb: "",

    itemsPerPage: 20,
  }),
  computed: {
    ...mapState("master", ["loadingTable", "user"]),
    ...mapGetters("access", [""]),
  },
  methods: {
    ...mapMutations("master", [
      "setUrl",
      "setOverlay",
      "setMenu",
      "setLoadingTable",
      "setTitleToolbar",
    ]),

    ...mapActions("master", ["requestApi", "alertNotification"]),

    cargarLista() {
      this.overlay = true;
      this.setLoadingTable(true);
      this.setUrl("api/resumen-piezas");
      this.requestApi({
        method: "GET",
        data: {
          awb: this.searchAwb,
          desde: this.desde,
          hasta: this.hasta,
        },
      })
        .then((res) => {
          this.lista = res.data;
          //this.pageCount = 10;
          this.setLoadingTable(false);
          this.overlay = false;
        })
        .catch(() => {})
        .finally(() => {
          this.setLoadingTable(false);
          this.overlay = false;
        });
    },

    exportar() {
      this.overlay = true;
      this.setUrl("api/resumen-piezas-exportar");

      this.requestApi({
        method: "POST",
        data: {
          awb: this.searchAwb,
          desde: this.desde,
          hasta: this.hasta,
        },
      })
        .then((res) => {
          let a = document.createElement("a");
          a.href = "data:application/xml;base64," + res.data.datos;
          a.download = res.data.archivo;
          a.click();
          //this.alertNotification({ param: { html: res.data.msg } });
          this.overlay = false;
        })
        .catch((res) => {
          this.overlay = false;
        })
        .finally((res) => {
          this.overlay = false;
        });
    },
  },

  mounted() {
    document.title = "Sistema de carga";
    this.setTitleToolbar("Resumen de piezas");
    this.cargarLista();
  },
};
</script>
